

export class LicenseToDriveStatusInput implements ILicenseToDriveStatusInput {
    /** The auto-generated id of the license to drive  master */
    licenseToDriveId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ILicenseToDriveStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseToDriveId = _data["licenseToDriveId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LicenseToDriveStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseToDriveStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseToDriveId"] = this.licenseToDriveId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ILicenseToDriveStatusInput {
    /** The auto-generated id of the license to drive  master */
    licenseToDriveId: number;
    /** The updated status */
    status: number;
}

